import React from "react";

import "../css/default.scss";
import "../css/personal.scss";

const Personal: React.FC<{show: boolean}> = ({show}) => {
  return (
    <div id="personal" className="section padded-section" style={{display: show ? "block" : "none"}}>
      <div id="page-content">
        <span>
          <div id="home-page-upper-grid">
            <div id="summary">
              <p>
                Kindly send me a message at{" "}
                <span>
                  <a href="mailto: markkeeble14@gmail.com" type="email">
                    markkeeble14@gmail.com
                  </a>
                </span>
                {" "}with any inquiries about projects or potential work!
              </p>
            </div>
          </div>
        </span>
      </div>
    </div>
  );
};

export default Personal;
